import { FC, memo, useContext } from 'react';
import LicenseContext from 'src/contexts/LicenseContext';

import CoursesPresenter from './CoursesPresenter';

/**
 * 表示する事業所を切り替えたら（SwitchCompanies は queryClient.clear() するだけで再読み込みしない）、画面を key で作り直す。
 * 作り直した observer が空のキャッシュから新しい会社の一覧・詳細を取り直し、選択・編集中の値も捨てる。
 * Why not query key に会社を入れるだけ: 選択中のコース・ダイヤや draft が前の会社の id のまま残る
 */
const Courses: FC = memo(() => {
  const licenseContext = useContext(LicenseContext);
  return <CoursesPresenter key={licenseContext.config?.selected_company_id ?? 0} />;
});

export default Courses;
